// // File: src/components/DocumentTemplates/LetterHead.js
// import React, { useRef, useState } from "react";
// import { useReactToPrint } from "react-to-print";

// const LetterHead = () => {
//     const [companyName, setCompanyName] = useState("Company Name Pvt. Ltd.");
//     const [logo, setLogo] = useState(null);
//     const [date, setDate] = useState(new Date().toISOString().substring(0, 10));
//     const [address, setAddress] = useState("123 Business Street, City, State, ZIP");
//     const [phone, setPhone] = useState("+1 (555) 123-4567");
//     const [email, setEmail] = useState("info@company.com");
//     const [website, setWebsite] = useState("www.company.com");
//     const [description, setDescription] = useState("");
//     const [signature, setSignature] = useState("Authorized Signatory");

//     const printRef = useRef();

//     const handlePrint = useReactToPrint({
//         content: () => printRef.current,
//         documentTitle: "LetterHead",
//     });

//     const handleLogoChange = (e) => {
//         const file = e.target.files[0];
//         if (file) setLogo(URL.createObjectURL(file));
//     };

//     return (
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6 bg-gray-100 min-h-screen">
//             {/* ---------- LEFT PANEL (Form) ---------- */}
//             <div className="space-y-4 bg-white p-6 rounded-lg shadow-md overflow-auto">
//                 <h2 className="text-xl font-bold text-gray-800">Letterhead Settings</h2>

//                 <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                         Company Logo
//                     </label>
//                     <input
//                         type="file"
//                         accept="image/*"
//                         onChange={handleLogoChange}
//                         className="w-full text-sm"
//                     />
//                 </div>

//                 <div>
//                     <label className="block text-sm font-medium">Company Name</label>
//                     <input
//                         type="text"
//                         value={companyName}
//                         onChange={(e) => setCompanyName(e.target.value)}
//                         className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500"
//                     />
//                 </div>

//                 <div>
//                     <label className="block text-sm font-medium">Date</label>
//                     <input
//                         type="date"
//                         value={date}
//                         onChange={(e) => setDate(e.target.value)}
//                         className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500"
//                     />
//                 </div>

//                 <div>
//                     <label className="block text-sm font-medium">Address</label>
//                     <input
//                         type="text"
//                         value={address}
//                         onChange={(e) => setAddress(e.target.value)}
//                         className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500"
//                     />
//                 </div>

//                 <div>
//                     <label className="block text-sm font-medium">Phone</label>
//                     <input
//                         type="text"
//                         value={phone}
//                         onChange={(e) => setPhone(e.target.value)}
//                         className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500"
//                     />
//                 </div>

//                 <div>
//                     <label className="block text-sm font-medium">Email</label>
//                     <input
//                         type="email"
//                         value={email}
//                         onChange={(e) => setEmail(e.target.value)}
//                         className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500"
//                     />
//                 </div>

//                 <div>
//                     <label className="block text-sm font-medium">Website</label>
//                     <input
//                         type="text"
//                         value={website}
//                         onChange={(e) => setWebsite(e.target.value)}
//                         className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500"
//                     />
//                 </div>

//                 <div>
//                     <label className="block text-sm font-medium">Description (Optional)</label>
//                     <textarea
//                         rows="3"
//                         value={description}
//                         onChange={(e) => setDescription(e.target.value)}
//                         className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500"
//                     />
//                 </div>

//                 <div>
//                     <label className="block text-sm font-medium">Signature</label>
//                     <input
//                         type="text"
//                         value={signature}
//                         onChange={(e) => setSignature(e.target.value)}
//                         className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500"
//                     />
//                 </div>

//                 <div className="flex gap-4 mt-6">
//                     <button
//                         onClick={handlePrint}
//                         className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//                     >
//                         Print / Download
//                     </button>
//                 </div>
//             </div>

//             {/* ---------- RIGHT PANEL (Preview) ---------- */}
//             <div
//                 ref={printRef}
//                 className="bg-white p-8 rounded-lg shadow-lg border relative"
//             >
//                 {/* Header */}
//                 <div className="flex flex-col items-center border-b-4 border-blue-600 pb-4 mb-6">
//                     {logo && <img src={logo} alt="Logo" className="h-16 mb-2" />}
//                     <h1 className="text-3xl font-extrabold text-gray-900">
//                         {companyName}
//                     </h1>
//                 </div>

//                 {/* Date */}
//                 <div className="text-right text-sm text-gray-600 mb-6">Date: {date}</div>

//                 {/* Description */}
//                 {description && (
//                     <div className="mb-8 text-gray-800 text-justify leading-relaxed">
//                         {description}
//                     </div>
//                 )}

//                 {/* Footer Info */}
//                 <div className="absolute bottom-20 left-0 w-full px-8">
//                     <div className="border-t border-gray-300 pt-4 text-center text-sm text-gray-700 space-y-1">
//                         <p>{address}</p>
//                         <p>{phone} | {email} | {website}</p>
//                     </div>
//                 </div>

//                 {/* Signature */}
//                 <div className="absolute bottom-6 right-12 text-center">
//                     <p className="font-medium text-gray-800">{signature}</p>
//                     <p className="text-xs text-gray-500">Signature</p>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default LetterHead;


// File: src/components/DocumentTemplates/LetterHead.js
import React, { useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import DocumentLayout from "../DocumentLayout";

const LetterHead = () => {
    const [companyName, setCompanyName] = useState("Company Name Pvt. Ltd.");
    const [address, setAddress] = useState("123 Business Street, City, State, ZIP");
    const [phone, setPhone] = useState("+1 (555) 123-4567");
    const [email, setEmail] = useState("info@company.com");
    const [website, setWebsite] = useState("www.company.com");
    const [selectedTemplate, setSelectedTemplate] = useState("1"); // default template 1

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: `${companyName}-LetterHead`,
    });

    // ----- Different Template Designs -----
    const renderTemplate = () => {
        switch (selectedTemplate) {
            case "1": // Classic Corporate
                return (
                    <div
                        ref={componentRef}
                        className="bg-white p-8 shadow-lg rounded border flex flex-col min-h-[1056px]" // A4 height approx
                    >
                        {/* Header */}
                        <div className="flex flex-col items-center border-b-4 border-blue-600 pb-4 mb-6">
                            <h1 className="text-3xl font-bold text-gray-900">{companyName}</h1>
                            <p className="text-gray-600">{website}</p>
                        </div>

                        {/* Date */}
                        <p className="text-right text-sm text-gray-600 mb-6">
                            Date: {new Date().toLocaleDateString()}
                        </p>

                        {/* Body */}
                        <div className="flex-1">
                            <p className="mb-12 text-gray-700 leading-relaxed">
                                Dear Sir/Madam,<br />
                                This is your official business letterhead template.
                            </p>
                        </div>

                        {/* Footer */}
                        <div className="border-t pt-4 mt-8 text-sm text-gray-700 flex flex-col items-center">
                            <p>
                                {address} | {phone} | {email}
                            </p>
                            <div className="mt-6 text-center">
                                <p className="font-medium">Authorized Signatory</p>
                                <p className="text-xs text-gray-500">Signature</p>
                            </div>
                        </div>
                    </div>
                );

            case "2":
                return (
                    <div ref={componentRef} className="bg-white shadow-lg flex relative min-h-[500px]">
                        <div className="bg-blue-700 text-white w-48 flex flex-col items-center p-4">
                            <h1 className="text-lg font-bold">{companyName}</h1>
                            <p className="text-xs text-center mt-2">{website}</p>
                        </div>
                        <div className="flex-1 p-8">
                            <p className="text-sm text-gray-600 mb-6">
                                Date: {new Date().toLocaleDateString()}
                            </p>
                            <p className="mb-12 text-gray-700 leading-relaxed">
                                Modern letterhead with a vertical sidebar design.
                            </p>
                            <div className="absolute bottom-6 right-12 text-center">
                                <p className="font-medium">Authorized Signatory</p>
                                <p className="text-xs text-gray-500">Signature</p>
                            </div>
                        </div>
                    </div>
                );

            case "3": // Minimal Line
                return (
                    <div ref={componentRef} className="bg-white p-8 shadow rounded border relative min-h-[500px]">
                        <div className="border-b-2 border-gray-400 pb-2 mb-6 flex justify-between items-center">
                            <h1 className="text-xl font-bold">{companyName}</h1>
                            <span className="text-sm">{website}</span>
                        </div>
                        <p className="text-sm text-gray-600 mb-6">
                            Date: {new Date().toLocaleDateString()}
                        </p>
                        <p className="mb-12 text-gray-700">
                            A minimal template for official use with clean lines.
                        </p>
                        <div className="border-t-2 border-gray-400 pt-2 text-center text-sm text-gray-600 absolute bottom-6 left-0 w-full">
                            {address} | {email} | {phone}
                        </div>
                    </div>
                );

            case "4": // Creative Header
                return (
                    <div ref={componentRef} className="bg-white shadow-lg rounded relative overflow-hidden min-h-[500px]">
                        <div className="bg-gradient-to-r from-blue-600 to-indigo-500 p-6 text-white">
                            <h1 className="text-2xl font-bold">{companyName}</h1>
                            <p className="text-sm">{website}</p>
                        </div>
                        <div className="p-8">
                            <p className="text-sm text-gray-600 mb-6">
                                Date: {new Date().toLocaleDateString()}
                            </p>
                            <p className="mb-12 text-gray-700 leading-relaxed">
                                A creative gradient header, perfect for design agencies.
                            </p>
                            <div className="absolute bottom-6 right-12 text-center">
                                <p className="font-medium">Authorized Signatory</p>
                                <p className="text-xs text-gray-500">Signature</p>
                            </div>
                        </div>
                    </div>
                );

            case "5": // Elegant Footer Bar
                return (
                    <div ref={componentRef} className="bg-white shadow-lg rounded relative min-h-[500px]">
                        <div className="p-8">
                            <h1 className="text-3xl font-bold text-gray-900 text-center mb-2">{companyName}</h1>
                            <p className="text-center text-gray-500">{website}</p>
                            <p className="text-sm text-gray-600 mt-6 mb-6">
                                Date: {new Date().toLocaleDateString()}
                            </p>
                            <p className="mb-12 text-gray-700 leading-relaxed text-center">
                                Elegant footer design for premium businesses.
                            </p>
                        </div>
                        <div className="absolute bottom-0 left-0 w-full bg-blue-600 text-white text-center py-3">
                            {address} | {email} | {phone}
                        </div>
                    </div>
                );

            default:
                return null;
        }
    };

    return (

        <div className="space-y-6 bg-slate-50 p-6">
            {/* Input Fields */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium">Company Name</label>
                        <input
                            type="text"
                            value={companyName}
                            onChange={(e) => setCompanyName(e.target.value)}
                            className="w-full p-2 border rounded"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium">Address</label>
                        <input
                            type="text"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            className="w-full p-2 border rounded"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium">Phone</label>
                        <input
                            type="text"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            className="w-full p-2 border rounded"
                        />
                    </div>
                </div>
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium">Email</label>
                        <input
                            type="text"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full p-2 border rounded"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium">Website</label>
                        <input
                            type="text"
                            value={website}
                            onChange={(e) => setWebsite(e.target.value)}
                            className="w-full p-2 border rounded"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium">Template Style</label>
                        <select
                            value={selectedTemplate}
                            onChange={(e) => setSelectedTemplate(e.target.value)}
                            className="w-full p-2 border rounded"
                        >
                            <option value="1">Classic Corporate</option>
                            <option value="2">Modern Sidebar</option>
                            <option value="3">Minimal Line</option>
                            <option value="4">Creative Gradient</option>
                            <option value="5">Elegant Footer</option>
                        </select>
                    </div>
                </div>
            </div>
            <DocumentLayout
                title="Letter Head"
                description="Company letterhead template for official correspondence"
                onSave={() => alert("Letter head saved!")}
                onDownload={handlePrint}
                onPrint={handlePrint}
            >
                {/* Preview */}
                <div className="mt-8 border rounded-lg overflow-hidden bg-gray-50">
                    {renderTemplate()}
                </div>
            </DocumentLayout>
        </div>
    );
};

export default LetterHead;
